import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11.172a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 22 8.828V20a2 2 0 0 1-2 2zm1.5-1.5H4a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h2.25V8c0 .414.336.75.75.75h8a.75.75 0 0 0 0-1.5H7.75V3.5h7.422a.5.5 0 0 1 .353.146l4.829 4.829a.5.5 0 0 1 .146.353V20a.5.5 0 0 1-.5.5h-1.5V15a2.5 2.5 0 0 0-2.5-2.5H8A2.5 2.5 0 0 0 5.5 15zm1.5 0h10V15a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }